require('./groupContractFilter.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const FeatureTogglingRender = require('components/conditionalRender/featureTogglingRender');

// @ helpers
const { ENABLED_CREDIT_CARD_FILTER } = require('constants/flagBasedFeatures');

class GroupContractFilter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: this.props.immFilter.toJS().groupContract.value,
        };

        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    handleFilterChange(value) {
        const selected = value;
        this.setState({
            selected,
        });
        this.props.onChangeSelected(value);
    }

    render() {
        return (
            <FeatureTogglingRender notAllowedProductKey={ENABLED_CREDIT_CARD_FILTER} >
                <section className="group-contracts-filter">
                    <header className="group-contracts-filter__title">
                        <FormattedText value="contractsFilter-title" />
                    </header>
                    <RadioButtonGroup
                        name="group-cotract-filter"
                        idPrefix="grouop-contract-filter-radio"
                        selectedValue={this.state.selected}
                        onChange={this.handleFilterChange}
                        className="group-contracts-filter__options"
                    >
                        <RadioButton
                            label={formatText('groupContractFilter-allContracts')}
                            value="2"
                            className="group-contracts-filter__radio-button"
                        />
                        <RadioButton
                            label={formatText('groupContractFilter-debitContract')}
                            value="0"
                            className="group-contracts-filter__radio-button"
                        />
                        <RadioButton
                            label={formatText('groupContractFilter-creditContract')}
                            value="1"
                            className="group-contracts-filter__radio-button"
                        />
                    </RadioButtonGroup>
                </section>
            </FeatureTogglingRender>
        );
    }
}

GroupContractFilter.propTypes = {
    immFilter: PropTypes.object.isRequired,
    onChangeSelected: PropTypes.func.isRequired
};

module.exports = GroupContractFilter;
